'use client';

import { Toast } from '@/shared';
import { FadeIn } from '@/shared/ui/fade-in';

import { useToast } from '../model';

export function ToastContainer() {
	const { toasts } = useToast();

	if (!toasts.length) {
		return null;
	}

	return (
		<div className="fixed bottom-5 right-1/2 z-[100] flex w-full max-w-sm translate-x-1/2 flex-col gap-2 space-y-2 md:bottom-auto md:right-5 md:top-5 md:translate-x-0">
			{toasts.map((toast) => (
				<FadeIn key={toast.id}>
					<Toast
						id={toast.id}
						title={toast.title}
						text={toast.text}
						type={toast.type}
					/>
				</FadeIn>
			))}
		</div>
	);
}
